import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const OptionsContainer = styled.div<{ isUpsellSimplified: boolean }>`
  margin-bottom: ${primitive.$spacing1};
  li > *:first-child {
    padding-left: 0;
    margin-left: ${primitive.$spacing4};
    border-bottom: ${p => p.theme.token('border-default')};
  }

  li:last-of-type > *:first-child {
    border-bottom: ${props => !props.isUpsellSimplified && 'none'};
  }
`;
